import React from "react";
import "./_button.scss";

const ViewMenu = props => {
  return <div className="viewtoggle-btn" {...props}></div>;
};

export default ViewMenu;
